"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _theme = require("../../components/theme");
var _sharedVariables = require("../../shared-variables");
require("./loading-spinner.css");
var _excluded = ["accessibleLabel", "size", "backgroundColor", "foregroundColor"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * A general-purpose loading spinner for use during data requests
 */
var LoadingSpinner = function LoadingSpinner(_ref) {
  var _ref$accessibleLabel = _ref.accessibleLabel,
    accessibleLabel = _ref$accessibleLabel === void 0 ? 'Loading' : _ref$accessibleLabel,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '50px' : _ref$size,
    backgroundColor = _ref.backgroundColor,
    foregroundColor = _ref.foregroundColor,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_theme.ThemeContext.Consumer, null, function (theme) {
    var colorScheme = theme === _theme.themes.dark ? {
      primary: 'colorWhite30',
      secondary: 'colorWhite'
    } : {
      primary: 'colorGreenLight',
      secondary: 'colorGreenAccent'
    };
    return /*#__PURE__*/_react["default"].createElement("div", otherProps, accessibleLabel !== 'NO_ARIA_LIVE' ? /*#__PURE__*/_react["default"].createElement("p", {
      "aria-live": "polite",
      className: "hiddenVisually"
    }, accessibleLabel) : null, /*#__PURE__*/_react["default"].createElement("svg", {
      "aria-hidden": true,
      height: size,
      shapeRendering: "auto",
      viewBox: "0 0 24 24",
      width: size,
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z",
      fill: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : _sharedVariables.variables[colorScheme.primary]
    }), /*#__PURE__*/_react["default"].createElement("path", {
      className: "sb-loading-spinner",
      d: "M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z",
      fill: foregroundColor !== null && foregroundColor !== void 0 ? foregroundColor : _sharedVariables.variables[colorScheme.secondary]
    })));
  });
};
LoadingSpinner.displayName = 'LoadingSpinner';
LoadingSpinner.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Optional prop to set the label for the aria-live region;
   * Default value: Loading
   * When set to "NO_ARIA_LIVE", the aria-live region won't be added.
   */
  accessibleLabel: _propTypes["default"].string,
  /**
   * Optional prop to set a size for the loading spinner, including a unit (px, em, %, etc).
   */
  size: _propTypes["default"].string,
  /**
   * Optional prop to define the color of the stationary part of the spinner.
   */
  backgroundColor: _propTypes["default"].string,
  /**
   * Optional prop to set the color of the moving part of the spinner.
   */
  foregroundColor: _propTypes["default"].string
} : {};
var _default = exports["default"] = LoadingSpinner;